import { p as r } from "../../_virtual/index3.js";
import { __require as p } from "./node_modules/react-is/index.js";
import { __require as s } from "./factoryWithTypeCheckers.js";
import { __require as t } from "./factoryWithThrowingShims.js";
var e;
function _() {
  if (e)
    return r.exports;
  if (e = 1, process.env.NODE_ENV !== "production") {
    var o = p(), i = !0;
    r.exports = s()(o.isElement, i);
  } else
    r.exports = t()();
  return r.exports;
}
export {
  _ as __require
};
//# sourceMappingURL=index.js.map
